import { createSlice } from "@reduxjs/toolkit";
import { loginUser } from "../thunk/userThunk";

const userSlice = createSlice({
  name: "user",
  initialState: {
    loading: true,
    adminData: {},
    error: "",
    isAuthenticated: false,
    isImpersonate: false,
    isNotification: false,
    notifyContent: "",
    usersList: [],
    usersListLoading: false,
    isPlanRoute: {
      profile: true,
      selectSubscriptionPlans: false,
      planAndBilling: false,
      billingHistory: false,
      selectUpdateSubscriptionPlans: false,
    },
  },
  reducers: {
    fetchingUserDetails: (state, action) => {
      state.loading = action.payload;
    },
    setIsAuthenticated: (state, action) => {
      state.isAuthenticated = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setUserDetails: (state, action) => {
      state.adminData = action.payload;
    },
    setImpersonate: (state, action) => {
      state.isImpersonate = action.payload;
    },
    clearAuthSlice: (state) => {
      state.loading = false;
      state.adminData = {};
      state.error = "";
      state.isAuthenticated = false;
      state.isImpersonate = false;
      state.isPlanRoute = {
        profile: false,
        planAndBilling: false,
        billingHistory: false,
        selectSubscriptionPlans: false,
        selectUpdateSubscriptionPlans: false,
      };
    },
    setPlanRoute: (state, action) => {
      const {
        profile,
        selectSubscriptionPlans,
        planAndBilling,
        billingHistory,
        selectUpdateSubscriptionPlans,
      } = action.payload;
      state.isPlanRoute.profile = profile;
      state.isPlanRoute.planAndBilling = planAndBilling;
      state.isPlanRoute.billingHistory = billingHistory;
      state.isPlanRoute.selectSubscriptionPlans = selectSubscriptionPlans;
      state.isPlanRoute.selectUpdateSubscriptionPlans =
        selectUpdateSubscriptionPlans;
    },
    setNotification: (state, action) => {
      state.isNotification = action.payload.isNotification;
      state.notifyContent = action.payload.notifyContent;
    },
    setProfileImage: (state, action) => {
      state.adminData.profileImageUrl = action.payload;
    },
    setUsersList: (state, action) => {
      state.usersList = action.payload;
    },
    setUsersListLoading: (state, action) => {
      state.usersListLoading = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.status = "loading";
      })
      .addCase(loginUser.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.isLoggedIn = true;
        state.userDetails = action.payload;
      })
      .addCase(loginUser.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const {
  fetchingUserDetails,
  setIsAuthenticated,
  setError,
  setUserDetails,
  setImpersonate,
  clearAuthSlice,
  setNotification,
  setPlanRoute,
  setProfileImage,
  setUsersList,
  setUsersListLoading,
} = userSlice.actions;

export default userSlice.reducer;
